import { Route, Routes } from "react-router-dom";
import { PrintingTechniqueCreatePage } from "./pages/printing-technique/Create";
import { ArtworkMasterCollectionCreatePage } from "./pages/collection/Create";
import { ArtworkMasterCollectionDetailPage } from "./pages/collection/Detail";
import { ArtworkMasterPage } from "./pages/MyApprovals";
import { MasterArtworkCollectionProvider } from "../../context/MasterArtworkCollectionContext";
import { MasterArtworkNumberProvider } from "context/MasterArtworkNumberContext";
import { MasterArtworkPrintingTechniqueProvider } from "context/MasterArtworkPrintingTechniqueContext";
import { MasterMyApprovalContextProvider } from "../../context/MasterArtworkMyApprovalsContext";
import Search from "./pages/Search";
import { ArtworkMasterNumberCreatePage } from "./pages/meta-artwork/number/Create";

import { PageableTableProvider } from "context/PageableTableContext";
import { ArtworkMasterNumberDetailPage } from "./pages/meta-artwork/number/Detail";
import { PrintingTechniqueDetailPage } from "./pages/printing-technique/Detail";
import { MetaArtworkSearchContext, SearchMetaArtworkProvider } from "../../context/MetaArtworkSearchContext";

export const MasterArtworkRoutes = () => {
  return (
    <Routes>
      <Route path="/">
        <Route
          index
          element={
            <MasterMyApprovalContextProvider>
              <ArtworkMasterPage title="Artwork Master - My Approval Requests" />
            </MasterMyApprovalContextProvider>
          }
        />

        <Route path="search">
          <Route
            path=""
            element={
            <SearchMetaArtworkProvider>
              <PageableTableProvider>
                <MasterArtworkCollectionProvider>
                  <MasterArtworkNumberProvider>
                    <MasterArtworkPrintingTechniqueProvider>
                      <Search />
                    </MasterArtworkPrintingTechniqueProvider>
                  </MasterArtworkNumberProvider>
                </MasterArtworkCollectionProvider>
              </PageableTableProvider>
            </SearchMetaArtworkProvider>
            }
          />
        </Route>

        <Route path="collections">
          <Route
            path="create"
            element={
              <MasterArtworkCollectionProvider>
                <ArtworkMasterCollectionCreatePage title="Create new Collection" />
              </MasterArtworkCollectionProvider>
            }
          />
          <Route
            path="detail/:code"
            element={
              <MasterArtworkCollectionProvider>
                <ArtworkMasterCollectionCreatePage title="Collection detail" />
              </MasterArtworkCollectionProvider>
            }
          />
          <Route
            path="requests/:id"
            element={
              <MasterArtworkCollectionProvider>
                <ArtworkMasterCollectionCreatePage title="Collection detail" />
              </MasterArtworkCollectionProvider>
            }
          />
        </Route>

        {/*TODO: CHANGE THAT URL TO meta-artwork*/}
        <Route path="meta-artwork/">
          <Route
            path="create"
            element={
              <MasterArtworkNumberProvider>
                <ArtworkMasterNumberCreatePage title="Create new Meta Artwork Number" />
              </MasterArtworkNumberProvider>
            }
          />
          <Route
            path="detail/:code"
            element={
              <MasterArtworkNumberProvider>
                <ArtworkMasterNumberCreatePage title="Meta Artwork Name Detail" />
              </MasterArtworkNumberProvider>
            }
          />
          <Route
            path="requests/:id"
            element={
              <MasterArtworkNumberProvider>
                <ArtworkMasterNumberCreatePage title="Meta Artwork Name Detail" />
              </MasterArtworkNumberProvider>
            }
          />
        </Route>

        <Route path="printing-technique">
          <Route
            path="create"
            element={
              <MasterArtworkPrintingTechniqueProvider>
                <PrintingTechniqueCreatePage title="Create new Artwork" />
              </MasterArtworkPrintingTechniqueProvider>
            }
          />

          <Route
            path="requests/:id"
            element={
              <PageableTableProvider>
                <MasterArtworkPrintingTechniqueProvider>
                  <PrintingTechniqueCreatePage title="View Artwork" />
                </MasterArtworkPrintingTechniqueProvider>
              </PageableTableProvider>
            }
          />
          <Route
            path="detail/:code"
            element={
              <PageableTableProvider>
                <MasterArtworkPrintingTechniqueProvider>
                  <PrintingTechniqueCreatePage title="View Artwork" />
                </MasterArtworkPrintingTechniqueProvider>
              </PageableTableProvider>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};
